
const AIBookAuthorityPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-indigo-600 to-purple-700 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl font-bold mb-6">AI Book Authority</h1>
            <p className="text-xl max-w-3xl mx-auto mb-8">
              Comprehensive AI education through expertly crafted books and publications on artificial intelligence.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://aibookauthority.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-indigo-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
              >
                Visit AI Book Authority
              </a>
              <a
                href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5?ref=ap_rdr&isDramIntegrated=true&shoppingPortalEnabled=true&ccs_id=043cae77-eaa8-440d-8b65-2edc56fe7c65"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-indigo-600 transition-colors"
              >
                Amazon Author Page
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Books Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Featured AI Publications</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover our comprehensive collection of AI books covering everything from fundamentals to advanced applications.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/febc62d062db3787eae6d05ce7021f63.jpg"
                  alt="AI Fundamentals Book"
                  className="h-48 w-32 object-cover rounded shadow-lg"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">AI Fundamentals for Business</h3>
                <p className="text-gray-600 mb-4">
                  A comprehensive guide to understanding artificial intelligence and its applications in modern business.
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-indigo-600">$24.99</span>
                  <a
                    href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors"
                  >
                    Buy Now
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 bg-gradient-to-br from-green-500 to-blue-600 flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Machine%20learning%20book%20cover%20with%20data%20visualization%20graphics%2C%20algorithms%20theme%2C%20professional%20design%2C%20technical%20illustration&width=300&height=400&seq=book2&orientation=portrait"
                  alt="Machine Learning Guide"
                  className="h-48 w-32 object-cover rounded shadow-lg"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Machine Learning Mastery</h3>
                <p className="text-gray-600 mb-4">
                  Advanced techniques and practical applications of machine learning for real-world problems.
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-indigo-600">$29.99</span>
                  <a
                    href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors"
                  >
                    Buy Now
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Deep%20learning%20book%20cover%20with%20neural%20network%20visualization%2C%20AI%20brain%20graphics%2C%20futuristic%20design%2C%20technology%20theme&width=300&height=400&seq=book3&orientation=portrait"
                  alt="Deep Learning Applications"
                  className="h-48 w-32 object-cover rounded shadow-lg"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Deep Learning Applications</h3>
                <p className="text-gray-600 mb-4">
                  Explore the cutting-edge world of deep learning and neural networks with practical examples.
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-indigo-600">$34.99</span>
                  <a
                    href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors"
                  >
                    Buy Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Author Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">About the Author</h2>
              <p className="text-xl text-gray-600 mb-6">
                Jeffery Long is a renowned expert in artificial intelligence and business development with over 40 years of experience in technology and corporate leadership.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-indigo-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Published Author</h3>
                    <p className="text-gray-600">Multiple bestselling books on AI and business strategy</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-indigo-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Industry Expert</h3>
                    <p className="text-gray-600">40+ years of experience in technology and business development</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-indigo-600 rounded-full flex items-center justify-center mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Thought Leader</h3>
                    <p className="text-gray-600">Regular speaker at AI conferences and industry events</p>
                  </div>
                </div>
              </div>

              <a
                href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition-colors"
              >
                View Author Profile
              </a>
            </div>

            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20author%20portrait%20in%20modern%20office%20setting%2C%20business%20executive%20writing%20books%2C%20AI%20technology%20background%2C%20confident%20and%20knowledgeable%20appearance&width=600&height=400&seq=author1&orientation=landscape"
                alt="Author Jeffery Long"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Book Categories */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Book Categories</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our comprehensive library covers all aspects of artificial intelligence and its business applications.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-indigo-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">AI Fundamentals</h3>
              <p className="text-gray-600">Essential concepts and principles of artificial intelligence</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-brain-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Machine Learning</h3>
              <p className="text-gray-600">Advanced algorithms and practical implementations</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Business AI</h3>
              <p className="text-gray-600">AI applications in business strategy and operations</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Innovation</h3>
              <p className="text-gray-600">Future trends and emerging AI technologies</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">What Readers Say</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover why thousands of professionals trust our AI publications for their learning journey.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-lg p-8">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "Exceptional clarity in explaining complex AI concepts. This book transformed how our company approaches artificial intelligence."
              </p>
              <div className="font-semibold text-gray-900">Sarah Johnson</div>
              <div className="text-gray-600">CTO, Tech Innovations Inc.</div>
            </div>

            <div className="bg-gray-50 rounded-lg p-8">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "Practical insights that we immediately implemented in our business. The ROI has been tremendous."
              </p>
              <div className="font-semibold text-gray-900">Michael Chen</div>
              <div className="text-gray-600">CEO, DataDriven Solutions</div>
            </div>

            <div className="bg-gray-50 rounded-lg p-8">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                "A must-read for anyone serious about understanding AI's impact on business. Highly recommended!"
              </p>
              <div className="font-semibold text-gray-900">Emily Rodriguez</div>
              <div className="text-gray-600">VP Strategy, Global Corp</div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact & Social Media Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Get In Touch</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Connect with the author for book signings, speaking engagements, or AI education inquiries.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-8">Contact Information</h3>
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Phone</h4>
                    <p className="text-gray-600 text-lg">928-963-2760</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center">
                    <i className="ri-mail-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Email</h4>
                    <p className="text-gray-600">info@aibookauthority.com</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center">
                    <i className="ri-linkedin-fill text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">LinkedIn</h4>
                    <a 
                      href="https://www.linkedin.com/in/jeffery-long-23b02a38a/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:text-indigo-700 transition-colors"
                    >
                      Connect with me
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center">
                    <i className="ri-global-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Website</h4>
                    <a 
                      href="https://aibookauthority.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:text-indigo-700 transition-colors"
                    >
                      aibookauthority.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center">
                    <i className="ri-amazon-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Amazon Store</h4>
                    <a 
                      href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:text-indigo-700 transition-colors"
                    >
                      Author Page
                    </a>
                  </div>
                </div>
              </div>

              {/* Social Media Links */}
              <div className="mt-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">Connect on Social Media</h4>
                <div className="flex space-x-4">
                  <a
                    href="https://www.linkedin.com/in/jeffery-long-23b02a38a/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white hover:bg-blue-700 transition-colors"
                  >
                    <i className="ri-linkedin-fill text-xl"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/profile.php?id=61587057361355"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center transition-colors"
                  >
                    <i className="ri-facebook-fill text-xl"></i>
                  </a>
                  <a
                    href="#"
                    className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-white hover:bg-blue-600 transition-colors"
                  >
                    <i className="ri-twitter-fill text-xl"></i>
                  </a>
                  <a
                    href="#"
                    className="w-12 h-12 bg-pink-600 rounded-full flex items-center justify-center text-white hover:bg-pink-700 transition-colors"
                  >
                    <i className="ri-instagram-fill text-xl"></i>
                  </a>
                </div>
              </div>

              {/* Back to Business Pages */}
              <div className="mt-8 p-6 bg-white rounded-lg shadow-lg">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">Explore My Other Services</h4>
                <div className="space-y-2">
                  <a href="/real-estate" className="block text-indigo-600 hover:text-indigo-700 transition-colors">
                    <i className="ri-arrow-right-line mr-2"></i>Real Estate Development
                  </a>
                  <a href="/ai-consulting" className="block text-indigo-600 hover:text-indigo-700 transition-colors">
                    <i className="ri-arrow-right-line mr-2"></i>AI Consulting Authority
                  </a>
                  <a href="/travel-authority" className="block text-indigo-600 hover:text-indigo-700 transition-colors">
                    <i className="ri-arrow-right-line mr-2"></i>Travel Authority
                  </a>
                  <a href="/books" className="block text-indigo-600 hover:text-indigo-700 transition-colors">
                    <i className="ri-arrow-right-line mr-2"></i>Complete Book Collection
                  </a>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Service Areas</h3>
              <p className="text-gray-600 mb-6">
                Available for speaking engagements and book signings worldwide, based in Northern California.
              </p>
              
              {/* Service Area Map */}
              <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d804686.2922526915!2d-122.3301083!3d38.5816223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809ac672b28397f9%3A0x921f6aaa74197fdb!2sSacramento%2C%20CA!5e0!3m2!1sen!2sus!4v1697000000000!5m2!1sen!2sus"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Service Areas Map"
                ></iframe>
              </div>
              
              <div className="mt-4 text-sm text-gray-600">
                <p><strong>Based in:</strong> Sacramento, California</p>
                <p><strong>Speaking Areas:</strong> Available worldwide for conferences, seminars, and book signings</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-indigo-600 to-purple-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Start Your AI Learning Journey</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Join thousands of professionals who have transformed their understanding of artificial intelligence through our publications.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://aibookauthority.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-indigo-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Browse All Books
            </a>
            <a
              href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-indigo-600 transition-colors whitespace-nowrap"
            >
              Amazon Store
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AIBookAuthorityPage;
